import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import UIButton from 'UIComponents/button/UIButton';
import { useState } from 'react';
import { useOAuthUrl } from '../../hooks/useOAuthUrl';
import { InstallWizard } from '../installFlow/InstallWizard';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OAuthUrlInstallButton({
  appDetails,
  isPreview,
  onClick,
  onTrackInteraction = () => null
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const {
    oauthUrl
  } = useOAuthUrl({
    offeringId: appDetails.offeringId,
    published: !isPreview
  });
  const oauthQueryParams = oauthUrl ? new URL(oauthUrl).search : '';

  // This handles the case where someone is previewing before defining
  // appUrl or oauthRedirectUrl on their draft
  if (isPreview && !oauthUrl) {
    /*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.installButton.install"
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      onClick: e => {
        setModalOpen(true);
        if (onClick) onClick(e);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.installButton.install"
      })
    }), modalOpen && /*#__PURE__*/_jsx(InstallWizard, {
      appId: appDetails.offering.sourceId,
      iconUrl: appDetails.iconUrl,
      isPreview: isPreview,
      isUIE: appDetails.uie,
      name: appDetails.name,
      oauthQueryParams: oauthQueryParams,
      offeringId: appDetails.offeringId,
      onClose: () => {
        onTrackInteraction('close install wizard');
        setModalOpen(false);
      },
      onTrackInteraction: onTrackInteraction,
      portalId: PortalIdParser.get()
    })]
  });
}